// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateRunPauseMutation($input: UpdateRunPauseInput!) {
    updateRunPause(input: $input) {
      runEdge {
        cursor
        node {
          id
          status
          scheduledStartAt
          scheduledEndAt
          setupTotalSeconds
          runTotalSeconds
          logs {
            id
            type
            notes
            createdAt
            user {
              id
              ...ProgressPanel_user
            }
          }
          ...RunControls_run
          ...SetupEndModal_run
          ...RunEndModal_run
          ...RunDetails_run
          ...RunYields_run
          ...RunLog_run
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
